import { baseApi } from "api/BaseApi";

import { ProjectPersonnel, ValidatorCheck } from "./personnel.types";

const PERSONNEL_BASE_URL = "project/personnel";

const personnelApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    isValidator: build.query<boolean, string | number>({
      query: (id) => ({
        url: `${PERSONNEL_BASE_URL}/is_validator/`,
        params: { product: id },
      }),
      transformResponse: (response: ValidatorCheck) => response.is_validator,
    }),

    productValidators: build.query<ProjectPersonnel[], string | number>({
      query: (id) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_validators`,
        params: { product: id, approved: true },
      }),
    }),

    getAllProductEvaluators: build.query<ProjectPersonnel[], string | number>({
      query: (productId) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_evaluators`,
        params: { product: productId },
      }),
    }),

    getApprovedProductValidators: build.query<
      ProjectPersonnel[],
      string | number
    >({
      query: (productId) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_validators`,
        params: { product: productId, approved: true },
      }),
    }),

    getApprovedAmValidators: build.query<ProjectPersonnel[], string | number>({
      query: (maintenanceId) => ({
        url: `${PERSONNEL_BASE_URL}/all_product_validators`,
        params: { maintenance: maintenanceId, approved: true },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useIsValidatorQuery,
  useProductValidatorsQuery,
  useGetAllProductEvaluatorsQuery,
  useGetApprovedProductValidatorsQuery,
  useGetApprovedAmValidatorsQuery,
} = personnelApi;
